import { css, tableSortLabelClasses as muiTableSortLabelClasses } from '@mui/material';

import type { ThemeOptions } from '@mui/material';

export const tableSortLabelThemes: ThemeOptions['components'] = {
  MuiTableSortLabel: {
    styleOverrides: {
      root: () => css`
        max-width: 100%;
        &.${muiTableSortLabelClasses.active} {
          color: inherit;
        }
      `,
      directionDesc: () => css``,
      directionAsc: () => css``,
      active: () => css``,
      icon: () => css`
        position: absolute;
        top: 2px;
        left: 2px;
        margin: 0;
      `,
    },
  },
};
